// sidebarConfig.js
import LeaderBoard from "./DynamicSidebar/LeaderBoard";
import Market from "./DynamicSidebar/Market";
import More from "./DynamicSidebar/More";
import Promo from "./DynamicSidebar/Promo";
import Support from "./DynamicSidebar/Support";
import TradeHitorySide from "./DynamicSidebar/TradeHitorySide";
import { Tutorial } from "./DynamicSidebar/Tutorial";
import Webinar from "./DynamicSidebar/Webinar";
import {
  TotalPortfolioIcon,
  TradingHistoryIcon,
  ChatIcon,
  LeaderBoardIcon,
  PromoIcon,
  WebinarsIcon,
  MarketIcon,
  TutorialsIcon,
  MoreIcon,
} from "./Icons/Icons";

export const sidebarConfig = (commonProps) => [
  {
    key: "traderoom",
    label: "TOTAL PORTFOLIO",
    icon: <TotalPortfolioIcon />,
    component: null,
    hide: true,
  },

  {
    key: "tradehistory",
    label: "TRADING HISTORY",
    icon: <TradingHistoryIcon />,
    component: <TradeHitorySide {...commonProps} />,
  },

  {
    key: "support",
    label: "CHATS & SUPPORT",
    icon: <ChatIcon />,
    component: <Support {...commonProps} />,
  },

  {
    key: "leaderboard",
    label: "LEADER BOARD",
    icon: <LeaderBoardIcon />,
    component: <LeaderBoard {...commonProps} />,
  },

  {
    key: "promo",
    label: "PROMO",
    icon: <PromoIcon />,
    component: <Promo {...commonProps} />,
  },

  {
    key: "webinar",
    label: "WEBINARS",
    icon: <WebinarsIcon />,
    component: <Webinar {...commonProps} />,
  },

  {
    key: "market",
    label: "MARKET ANALYSIS",
    icon: <MarketIcon />,
    component: <Market {...commonProps} />,
  },

  {
    key: "guide",
    label: "TUTORIALS",
    icon: <TutorialsIcon />,
    component: <Tutorial {...commonProps} />,
  },

  {
    key: "more",
    label: "MORE",
    icon: <MoreIcon />,
    component: <More {...commonProps} />,
  },

  {
    key: "logout",
    label: "LOG OUT",
    logout: true,
    icon: (
      <img
        width="16"
        src="https://img.icons8.com/ios-filled/50/logout-rounded-left.png"
        style={{
          filter:
            "invert(18%) sepia(96%) saturate(7472%) hue-rotate(355deg) brightness(100%) contrast(101%)",
        }}
      />
    ),
    component: null,
  },
];
